import React, { useState } from "react";
import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";
import addToMailchimp from "gatsby-plugin-mailchimp";
import { LocalToastTarget, useLocalToast } from "react-local-toast";
import { Col, Visible } from "react-grid-system";

import Link from "../Link";
import ExternalLink from "../ExternalLink";

import ExternalLinks from "../../utils/externalLinks";
import InternalLinks from "../../utils/internalLinks";

import {
  FooterContainer,
  MailContainer,
  DescriptionMessage,
  InputMail,
  RedirectsContainer,
  LinksGroup,
  ConstellationInformationContainer,
  ConstellationContainer,
  ConstellationLogo,
  ConstellationRights,
  RedirectLinksContainer,
  LinksHeader,
  SocialMediaContainer,
  SocialMedias,
  PoliciesContainer,
  SubmitButton,
  CustomColumn,
} from "./styles";

import GithubLogo from "../../img/logos/github.svg";
import TelegramLogo from "../../img/logos/telegram.svg";
import TwitterLogo from "../../img/logos/twitter.svg";
import MediumLogo from "../../img/logos/medium.svg";
import YoutubeLogo from "../../img/logos/youtube.svg";
import RightArrow from "../../img/right-arrow.svg";

const Footer = () => {
  const intl = useIntl();
  const { showToast } = useLocalToast();
  const [mail, setMail] = useState("");

  const handleChange = (event) => {
    setMail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const result = await addToMailchimp(mail);
    if (result.result === "error") {
      showToast(
        "btn",
        <div>
          <span style={{ color: "#FFF" }}>{result.msg}</span>
        </div>,
        { type: "error" }
      );
      setMail("");
      return;
    }

    showToast(
      "btn",
      <div>
        <span style={{ color: "#FFF" }}>Mail subscribed successfully 😊</span>
      </div>,
      { type: "success" }
    );
    setMail("");
  };

  return (
    <FooterContainer fluid>
      <MailContainer>
        <Col xs={0} sm={0} md={0} lg={2} xl={3} />
        <Col xs={12} sm={12} md={12} lg={2} xl={2}>
          <DescriptionMessage>
            <strong>
              <FormattedMessage id="stay_informed" />
            </strong>
            <span>
              <FormattedMessage id="no_spam" />
            </span>
          </DescriptionMessage>
          <Col xl={3} />
        </Col>
        <CustomColumn
          xs={10}
          sm={10}
          md={10}
          lg={4}
          xl={4}
          offset={{ xs: 1, sm: 1, md: 1 }}
        >
          <LocalToastTarget name="btn">
            <InputMail onSubmit={handleSubmit}>
              <input
                type="text"
                value={mail}
                onChange={handleChange}
                placeholder={intl.formatMessage({ id: "your_email" })}
              />
              <Visible lg xl xxl xxxl>
                <SubmitButton type="submit">
                  <span>
                    <FormattedMessage id="okay" />
                  </span>
                  <RightArrow size={15} />
                </SubmitButton>
              </Visible>
              <Visible xs sm md>
                <SubmitButton type="submit">
                  <span>
                    <FormattedMessage id="okay" />
                  </span>
                  <RightArrow size={15} />
                </SubmitButton>
              </Visible>
            </InputMail>
          </LocalToastTarget>
        </CustomColumn>
      </MailContainer>
      <RedirectsContainer>
        <Visible xl xxl xxxl lg>
          <Col lg={3} xl={3}>
            <ConstellationInformationContainer>
              <Link to={InternalLinks.HOME}>
                <ConstellationContainer>
                  <ConstellationLogo />
                  <aside>Constellation</aside>
                </ConstellationContainer>
              </Link>
            </ConstellationInformationContainer>
          </Col>
        </Visible>

        <Col xs={6} sm={6} md={6} lg={2} xl={2}>
          <RedirectLinksContainer>
            <LinksHeader>
              <FormattedMessage id="nav.products" />
            </LinksHeader>
            <LinksGroup>
              <Link to={InternalLinks.DIGITAL_EVIDENCE}>
                <FormattedMessage id="nav.digital_evidence" />
              </Link>
              <Link to={InternalLinks.DTM}>
                <FormattedMessage id="nav.dtm" />
              </Link>
              <Link to={InternalLinks.FEDERAL}>
                <FormattedMessage id="nav.federal" />
              </Link>
              <Link to={InternalLinks.STARGAZER_WALLET}>
                <FormattedMessage id="nav.stargazer_wallet" />
              </Link>
            </LinksGroup>
          </RedirectLinksContainer>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2} xl={2}>
          <RedirectLinksContainer>
            <LinksHeader>
              <FormattedMessage id="nav.build" />
            </LinksHeader>
            <LinksGroup>
              <Link to={InternalLinks.GET_STARTED}>
                <FormattedMessage id="nav.get_started" />
              </Link>
              <ExternalLink href={ExternalLinks.DEVDOCS}>
                <FormattedMessage id="nav.developer_docs" />
              </ExternalLink>
              <Link to={InternalLinks.SNAPSHOT_FEE_CALCULATOR}>
                <FormattedMessage id="nav.snapshot_fee_calculator" />
              </Link>
              <ExternalLink href={ExternalLinks.METANOMICS}>
                <FormattedMessage id="nav.tokenomics" />
              </ExternalLink>
              <ExternalLink href={ExternalLinks.DISCORD_INVITE}>
                <FormattedMessage id="nav.discord" />
              </ExternalLink>
            </LinksGroup>
          </RedirectLinksContainer>
        </Col>

        <Col xs={6} sm={6} md={6} lg={2} xl={2}>
          <RedirectLinksContainer>
            <LinksHeader>
              <FormattedMessage id="nav.ecosystem" />
            </LinksHeader>
            <LinksGroup>
              <Link to={InternalLinks.DAG_TOKEN}>
                <FormattedMessage id="nav.what_is_dag" />
              </Link>
              <Link to={InternalLinks.GET_DAG}>
                <FormattedMessage id="nav.get_$dag" />
              </Link>
              <Link to={InternalLinks.STARGAZER_WALLET}>
                <FormattedMessage id="nav.stargazer_wallet" />
              </Link>
              <ExternalLink href={ExternalLinks.DAG_EXPLORER}>
                <FormattedMessage id="nav.dag_explorer_title" />
              </ExternalLink>
              <Link to={InternalLinks.PACASWAP}>  
                <FormattedMessage id="nav.pacaswap" />
              </Link>
              <Link to={InternalLinks.LATTICE}> 
                <FormattedMessage id="nav.lattice_title" />  
              </Link>
              <ExternalLink href={ExternalLinks.BRIDGE_DAG}>
                <FormattedMessage id="nav.bridge_dag" />
              </ExternalLink>
            </LinksGroup>
          </RedirectLinksContainer>
        </Col>
        <Col xs={6} sm={6} md={6} lg={2} xl={2}>
          <RedirectLinksContainer>
            <LinksHeader>
              <FormattedMessage id="nav.company" />
            </LinksHeader>
            <LinksGroup>
              <Link to={InternalLinks.TEAM}>
                <FormattedMessage id="nav.team" />
              </Link>
              <Link to={InternalLinks.CAREERS}>
                <FormattedMessage id="nav.now_hiring" />
              </Link>
              <Link to={InternalLinks.COMMUNITY}>
                <FormattedMessage id="nav.join_community" />
              </Link>
            </LinksGroup>
          </RedirectLinksContainer>
        </Col>
      </RedirectsContainer>
      <SocialMediaContainer>
        <Visible xl xxl xxxl lg>
          <Col xl={5} lg={5}>
            <ConstellationRights>
              © {new Date().getFullYear()} Constellation Network
            </ConstellationRights>
          </Col>
        </Visible>
        <Col xs={12} sm={12} md={12} lg={4} xl={4}>
          <PoliciesContainer>
            <Link to={InternalLinks.TERMS_OF_SERVICE}>
              <FormattedMessage id="nav.terms_of_use" />
            </Link>
            <Link to={InternalLinks.PRIVACY_POLICY}>
              <FormattedMessage id="nav.privacy_policy" />
            </Link>
            <Link to={InternalLinks.PRIVACY_POLICY}>
              <FormattedMessage id="nav.data_privacy" />
            </Link>
          </PoliciesContainer>
        </Col>
        <Visible xs sm md>
          <Col xs={12} sm={12} md={12}>
            <ConstellationRights>
              © {new Date().getFullYear()} Constellation Network
            </ConstellationRights>
          </Col>
        </Visible>
        <Col>
          <SocialMedias>
            <ExternalLink href={ExternalLinks.TELEGRAM}>
              <TelegramLogo />
            </ExternalLink>
            <ExternalLink href={ExternalLinks.GITHUB}>
              <GithubLogo />
            </ExternalLink>
            <ExternalLink href={ExternalLinks.TWITTER}>
              <TwitterLogo />
            </ExternalLink>
            <ExternalLink href={ExternalLinks.YOUTUBE}>
              <YoutubeLogo />
            </ExternalLink>
            <ExternalLink href={ExternalLinks.MEDIUM}>
              <MediumLogo />
            </ExternalLink>
          </SocialMedias>
        </Col>
      </SocialMediaContainer>
    </FooterContainer>
  );
};

export default Footer;
